import React, { ReactNode } from "react";
import { Navigate } from 'react-router-dom';

const EUCRMHome = React.lazy(() => import('../pages/eucrm/eucrm-home'));
const EUCRMHotel = React.lazy(() => import('../pages/eucrm/eucrm-hotel-travel'));
const EUCRMRegister = React.lazy(() => import('../pages/eucrm/eucrm-register'));
const EUCRMSchedule = React.lazy(() => import('../pages/eucrm/eucrm-schedule'));
const EUCRMExhibitorsSponsorships = React.lazy(() => import('../pages/eucrm/eucrm-sponsorship'));

const PageNotFound = React.lazy(() => import("../pages/errors/page-not-found"));

export type route = {
    component: ReactNode;
    exact: boolean | undefined;
    name?: string;
    path: string;
    routes?: route[];
};

const EUCRMConference: route[] = [
  { path: '/', exact: true, name: 'EUCRM Home', component: <Navigate to={`/eucrm/home${window.location.search}`} replace /> },
  { path: '/home', exact: true, name: 'EUCRM Home', component: <EUCRMHome /> },
  { path: '/sponsorship', exact: true, name: 'EUCRM', component: <EUCRMExhibitorsSponsorships /> },
  { path: '/hotel', exact: true, name: 'EUCRM Hotel', component: <EUCRMHotel /> },
  { path: '/register', exact: true, name: 'EUCRM About', component: <EUCRMRegister /> },
  { path: '/schedule', exact: true, name: 'EUCRM Schedule', component: <EUCRMSchedule /> },

  //alternate urls
  { path: '/exhibitors-sponsorships', exact: true, name: 'EUCRM', component: <EUCRMExhibitorsSponsorships /> },
  { path: '/hotel-travel', exact: true, name: 'EUCRM', component: <EUCRMHotel /> },
  { path: '/schedule-at-a-glance', exact: true, component: <EUCRMSchedule /> },
  //end of alternate urls

  { path: '/*', exact: true, component: <PageNotFound /> },
]
export default EUCRMConference;
